/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	paginationDetails: {
		flex: 1,
		textAlign: 'right',
		marginTop: token('space.100'),
		marginBottom: token('space.100'),
		marginLeft: token('space.200'),
		marginRight: token('space.200'),
		font: token('font.body'),
		color: token('color.text.subtlest'),
	},
});

export const PaginationDetailsStyled = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styles.paginationDetails} {...props}>
		{children}
	</div>
);
